import { render, staticRenderFns } from "./OscillographyAnalysisDiagnosticsTab.vue?vue&type=template&id=8d21719c&scoped=true&"
import script from "./OscillographyAnalysisDiagnosticsTab.vue?vue&type=script&lang=js&"
export * from "./OscillographyAnalysisDiagnosticsTab.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyAnalysisDiagnosticsTab.vue?vue&type=style&index=0&id=8d21719c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d21719c",
  null
  
)

export default component.exports